import { ReactElement } from 'react';
import classNames from 'classnames';

import { SiteFeature } from '../../../types/siteSettings';
import { Button } from '../../Button/Button';
import { FeatureToggle } from '../../FeatureToggle/FeatureToggle';

import basketStyles from '../Basket.module.css';
import engravingStyles from './Engraving.module.css';

const EngravingSkeletonLoader = (): ReactElement | null => {
  return (
    <FeatureToggle featureName={SiteFeature.SfccBasketEngraving}>
      <div
        className={classNames(basketStyles.card, basketStyles.grey, engravingStyles.container)}
        aria-hidden
      >
        <div className="flex-0 space-between flex flex-row items-center">
          <div className="flex flex-1 flex-col">
            <span className={engravingStyles.engravingWord}>
              <span className="animate-thin-glow">xxxxxx xxxxxx</span>
            </span>
            <span className={classNames(basketStyles.fat, engravingStyles.engravingText)}>
              <span className="animate-thin-glow">xxxxxx xxxxxx xxxxxx</span>
            </span>
          </div>

          <div className="flex-0 flex gap-4">
            <Button variant="tertiary" size="s" showSkeletonLoader>
              <span className="invisible text-[0.75rem]">xxxx xxxxxx</span>
            </Button>
          </div>
        </div>
      </div>
    </FeatureToggle>
  );
};
export default EngravingSkeletonLoader;
